import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { mergeMap, switchMap } from 'rxjs/operators';

import {
  ForgotPasswordFailure,
  ForgotPasswordSuccess,
  GetProfileFailure,
  GetProfileSuccess,
  UpdateProfileFailure,
  UpdateProfileSuccess,
} from '../../Redux/Actions/ProfileAction';
import { FORGOT_PASSWORD, GET_ADMIN_PROFILE, UPDATE_ADMIN_PROFILE } from '../../Redux/Actiontype';
import { Basepath } from '../../config';

const clearSession = msg => {
  localStorage.clear();
  alert(msg);
  window.location = '/';
};
export const UpdateAdminProfileEpic = action$ =>
  action$.pipe(
    ofType(UPDATE_ADMIN_PROFILE),
    switchMap(action =>
      ajax
        .post(
          `${Basepath}/api/admin/updateAdminProfile
          `,
          action.payload,
          {
            authentication: localStorage.getItem('sessionId'),
          },
        )
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(UpdateProfileSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(UpdateProfileFailure(response.response));
            }
          }),
        ),
    ),
  );

export const GetAdminProfileEpic = action$ =>
  action$.pipe(
    ofType(GET_ADMIN_PROFILE),
    switchMap(action =>
      ajax
        .get(
          `${Basepath}/api/admin/getAdminProfile
        `,

          {
            authentication: localStorage.getItem('sessionId'),
          },
        )
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(GetProfileSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(GetProfileFailure(response.response));
            }
          }),
        ),
    ),
  );

export const ForgotPassEpic = action$ =>
  action$.pipe(
    ofType(FORGOT_PASSWORD),
    switchMap(action =>
      ajax
        .post(
          `${Basepath}/api/admin/forgetPassword
          `,
          action.payload,
        )
        .pipe(
          mergeMap(response => {
            if (response.response.status === 200) {
              return of(ForgotPasswordSuccess(response.response));
            } else {
              return of(ForgotPasswordFailure(response.response));
            }
          }),
        ),
    ),
  );
